import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, Form, Button, InputGroup, Spinner } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import BR from 'date-fns/locale/pt-BR';
import Select from 'react-select';
import Currency, {
  currencyReverse,
  EuroCurrency,
  DollarCurrency,
} from 'helpers/Currency';
import FileUploadMultiple from 'components/FileUploadMultiple';
import ActionsFormTasks from 'components/Actions/Form/Tasks';
import ActionsFormFunds from 'components/Actions/Form/Funds';
import ActionsMarginResume from 'components/Actions/Form/Resume';
import ExtraMaterial from 'components/Actions/Form/ExtraMaterial';
import PadLock from 'components/PadLock';
import ActionStatus from 'enums/ActionStatus';
import { DashboardOutlined } from '@material-ui/icons';
import { api } from 'services';

registerLocale('pt_BR', BR);

const ActionsFormAction = ({
  planId,
  actionId,
  position,
  currentStatus,
  events,
  eventId,
  name,
  setName,
  vendorId,
  setVendorId,
  company,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  paymentDate,
  setPaymentDate,
  rule,
  task,
  hasAmountTasks,
  amount_tasks,
  taskItems,
  setTaskItems,
  taskItemsIsInternal,
  setTaskItemsIsInternal,
  description,
  setDescription,
  files,
  setFiles,
  filesBriefing,
  setFilesBriefing,
  filesComments,
  setFilesComments,
  filesBriefingComments,
  setFilesBriefingComments,
  actionExistingFiles,
  actionExistingFilesBriefing,
  funds,
  setFunds,
  fundExtra,
  setFundExtra,
  companies,
  rules,
  tasks,
  periodFunds,
  handleChangeCompany,
  handleChangePeriod,
  handleAddQuantity,
  handleReduceQuantity,
  handleChangeTask,
  handleEventId,
  editable,
  extra_materials,
  setExtraMaterials,
  deleted_extra_materials,
  setDeletedExtraMaterials,
  atividade,
  setAtividade,
  valueExpected,
  setValueExpected,
  quotaType,
  setQuotaType,
  VendorsArr,
  totalFundsExpireValue,
  setTotalFundsExpireValue,
  currency,
  handleChangeCurrency,
  statusNow,
  isCreative,
  valor, setValor,
  publico, setPublico,
  type, setType,
  courtesy, setCourtesy,
  userCreative, setUserCreative,
  materialComplete, setMaterialComplete,
  artComprovations
}) => {
  const [total, setTotal] = useState(0);
  const EventsArr = [];
  const { t } = useTranslation();
  const [userList, setUserList] = useState([]);
  const [currentMaterialComplete, setCurrentMaterialComplete] = useState(materialComplete)
  const [isLoading, setIsLoading] = useState(false)
  const [hideButtonConfirm, setHideButtonConfirm] = useState(false)

  useEffect(() => {
    if(taskItemsIsInternal == 1){
      api.get(`by-profile/8`).then(({ data }) => {
        setUserList(data.map(user=>{
          return {label:(user.firstname+' '+user.lastname).toUpperCase(), value:user.id};
        }))
      });
    } else {
      setUserCreative('');
    }
  },[taskItemsIsInternal])

  useEffect(() => {
    var sum = 0;
    funds.map(
      (fund) =>
        (sum += !!currencyReverse(String(fund.value))
          ? currencyReverse(String(fund.value))
          : 0)
    );
    setTotal(sum);
  }, [funds]);

  const readOnlySelect = {
    style: { background: '#eee', pointerEvents: 'none', touchAction: 'none' },
    tabIndex: -1,
  };

  const getVendors = () => {
    companies.map((company) => {
      return VendorsArr.push({
        label: company.alias,
        value: company.id,
      });
    });

    VendorsArr.sort((a, b) => {
      return +(a.label > b.label) || +(a.label === b.label) - 1;
    });

    VendorsArr.map((label) => {
      return companies[label.index];
    });
  };

  const findVendors = (value) => {
    let flag;
    VendorsArr.map((v, k) => {
      if (value === v.value) {
        flag = k;
      }
    });
    return flag;
  };

  const getEvents = () => {
    events.map((event) => {
      return EventsArr.push({
        label: event.name,
        value: event.id,
      });
    });

    EventsArr.sort((a, b) => {
      return +(a.label > b.label) || +(a.label === b.label) - 1;
    });

    EventsArr.map((label) => {
      return events[label.index];
    });
  };

  const findEvents = (value) => {
    let flag;
    EventsArr.map((v, k) => {
      if (value === v.value) {
        flag = v;
      }
    });
    return flag;
  };

  const handleChangeStartDate = (date) => {
    setStartDate(date);
  };

  const handleChangeEndDate = (date) => {
    setEndDate(date);
  };

  const isRealValue = (status) => {
    let statuses = [14, 16, 17, 18];
    return statuses.includes(status);
  };

  const showVendorId = (status) => {
    let statuses = [9, 13, 14, 15, 17, 18, 19, 21, 22];
    return statuses.includes(status);
  };

  const verifyStatusToEnableMaterialComplete = status => {
    return [5, 6, 7, 22, 25, 26].includes(status)
  }

  getVendors();
  getEvents();

  const atividadeDropDown = (
    <>
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>{t('label:activity')}</Form.Label>
            <Form.Control
              as="select"
              value={task}
              onChange={handleChangeTask}
              required={atividade === 'atividade' ? true : false}
              {...(!editable ? readOnlySelect : {})}
            >
              <option disabled value="">
                {t('label:select')}
              </option>
              {tasks.map((group, k) => (
                <optgroup key={k} label={t(`task:${group.name}`)}>
                  {group.tasks.map((task, k2) => (
                    <option key={k2} value={task.id}>
                      {t(`task:${task.name}`)}
                    </option>
                  ))}
                </optgroup>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
        {hasAmountTasks ? (
          <>
            <Col
              md={2}
              style={{ display: !hasAmountTasks ? 'none' : null }}
            >
              <Form.Group>
                <Form.Label>{t('label:quantity')}</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend style={{zIndex:'1'}}>
                    <Button
                      onClick={handleReduceQuantity}
                      variant="secondary"
                      size="sm"
                      disabled={!editable}
                    >
                      <i className="fas fa-minus" />
                    </Button>
                  </InputGroup.Prepend>
                  <Form.Control
                    value={amount_tasks}
                    required={hasAmountTasks}
                    tabIndex="-1"
                    style={{
                      pointerEvents: 'none',
                      textAlign: 'center',
                    }}
                    onChange={() => { }}
                    {...(!editable ? readOnlySelect : {})}
                  />
                  <InputGroup.Append style={{zIndex:'1'}}>
                    <Button
                      onClick={handleAddQuantity}
                      size="sm"
                      variant="secondary"
                      disabled={!editable}
                    >
                      <i className="fas fa-plus" />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </Form.Group>
            </Col>
            {/* <Col xs={2} md={2} style={{ display: !hasAmountTasks ? 'none' : null }}> */}
                    
            {/*<Col md="2">
              <Form.Group>
                <Form.Label>Material Completo ?</Form.Label>
                <Row>
                  <Col sm="8">
                    <Form.Control
                      as="select"
                      value={currentMaterialComplete}
                      disabled={currentMaterialComplete == 1 && currentStatus || !verifyStatusToEnableMaterialComplete(currentStatus)}
                      onChange={e => {
                        setCurrentMaterialComplete(parseInt(e.target.value))
                      }}
                    >
                      <option value={1}>Sim</option>
                      <option value={0}>Não</option>
                    </Form.Control>
                  </Col>
                  {currentMaterialComplete != materialComplete && !hideButtonConfirm ? (
                    <Col sm="4">
                      <Button 
                        size="sm" 
                        variant="success"
                        disabled={isLoading}
                        onClick={() => {
                          if (actionExistingFilesBriefing.length == 0) {
                            swal.error('O material não pode ser marcado como completo, pois a ação não possui arquivos de briefing!');
                            return;
                          }

                          setIsLoading(true)
                          api.post('/actions/change-material-complete/'+actionId, {
                            material_complete: currentMaterialComplete
                          })
                          .then(() => {
                            swal.success('Material marcado como completo')
                            setCurrentMaterialComplete(currentMaterialComplete)
                            setHideButtonConfirm(true)
                          })
                          .finally(() => setIsLoading(false))
                        }}
                      >
                        {isLoading ? <Spinner animation="border" size="sm" style={{ color: '#ffffff' }} /> : <Check fontSize="small" />}
                      </Button>
                    </Col>
                  ):(<></>)}
                </Row>
              </Form.Group>
            </Col>*/}
          </>
        ) : (
          ''
        )}

        {isCreative ? (<>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Interno ou Agência</Form.Label>
              <Form.Control
                as="select"
                value={taskItemsIsInternal}
                onChange={(e) => setTaskItemsIsInternal(e.target.value)}
                required={hasAmountTasks}
                disabled={!editable}
              >
                <option disabled value="">
                  {t('label:select')}
                </option>
                <option value="1">Interno</option>
                <option value="0">Agência</option>
              </Form.Control>
            </Form.Group>
          </Col>
          {taskItemsIsInternal==1?(
            <Col md={2}>
              <Form.Group>
                <Form.Label>Responsável</Form.Label>
                <Form.Control
                  as="select"
                  value={userCreative}
                  onChange={(e) => setUserCreative(e.target.value)}
                  disabled={!editable}
                >
                  <option value="">
                    {t('label:select')}
                  </option>
                  {userList.map(user=>{
                    return <option value={user.value}>{user.label}</option>
                  })}
                </Form.Control>
              </Form.Group>
          </Col>
          ):''}
          {task==53?(
          <>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Público</Form.Label>
                <Form.Control
                  value={publico}
                  onChange={(e) => setPublico(e.target.value)}
                  required={hasAmountTasks}
                  disabled={!editable}
                >
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Valor</Form.Label>
                <Currency
                  value={valor?valor:''}
                  onChange={(e) => setValor(e.target.value)}
                  required={hasAmountTasks}
                  disabled={!editable}
                />
              </Form.Group>
            </Col>
          </>
          ):''}
        </>) : (
          ''
        )}
        {task==52?(
          <>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Tipo</Form.Label>
                <Form.Control
                  as="select"
                  value={type?type:''}
                  onChange={(e) => setType(e.target.value)}
                  required={hasAmountTasks}
                  disabled={!editable}
                >
                  <option disabled value="">
                    {t('label:select')}
                  </option>
                  <option value="1">Jornada </option>
                  <option value="0">Post Individual</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Público</Form.Label>
                <Form.Control
                  as="select"
                  value={publico?publico:''}
                  onChange={(e) => setPublico(e.target.value)}
                  required={hasAmountTasks}
                  disabled={!editable}
                >
                  <option disabled value="">
                    {t('label:select')}
                  </option>
                  <option value="Cliente Final">Cliente Final</option>
                  <option value="Revenda">Revenda</option>
                  <option value="Time ScanSource">Time ScanSource</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </>
        ):''}

      </Row>
    </>
  );

  const getDefaultEvent = useCallback((EventsArr) => {
    const l_f = EventsArr.filter( event => {
      return event.value == eventId
    } );
    const defaultValue = l_f.length > 0?l_f[0]:null;
    return defaultValue
  },[]);

  const getCurrency = () => {
    switch (currency) {
      case '1':
        return (
          <Currency
            value={valueExpected ? currencyReverse(valueExpected) : ''}
            onChange={(e) => setValueExpected(e.target.value)}
            disabled={!editable}
            placeholder={t('label:insert here')}
            className="col-9"
          />
        );
        break;
      case '2':
        return (
          <DollarCurrency
            value={valueExpected ? currencyReverse(valueExpected) : ''}
            onChange={(e) => setValueExpected(e.target.value)}
            disabled={!editable}
            placeholder={t('label:insert here')}
            className="col-9"
          />
        );
        break;
      case '3':
        return (
          <EuroCurrency
            value={valueExpected ? currencyReverse(valueExpected) : ''}
            onChange={(e) => setValueExpected(e.target.value)}
            disabled={!editable}
            placeholder={t('label:insert here')}
            className="col-9"
          />
        );
        break;
      default:
        break;
    }
  };

  const getIsCriativo = () => {
    return isCreative;
  }

  return (
    <>
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">
            {atividade === 'atividade'
              ? `${t('title:action')} - ${name}`
              : atividade === 'evento'
                ? `${t('title:event action')} - ${name}`
                : t('title:action register')}
            {!!planId && !!actionId && (
              <>
                &nbsp;-&nbsp;
                <Link to={`/marketing-plans/edit/${planId}`}>
                  {t('title:marketing plan')} #{planId}
                </Link>
              </>
            )}
          </h4>
        </Col>
        <Col xs="auto" className="">
          <Form.Check
            disabled={!editable}
            type="switch"
            label="Ação de Cortesia"
            id="disabled-custom-switch"
            checked={courtesy}
            onChange={(e)=>{
              setCourtesy(e.target.checked);
            }}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          {!editable ? <PadLock /> : null}
          <Row>
            {!!actionId && atividade === 'atividade' ? (
              <Col>
                <>
                  <ActionsMarginResume
                    actionId={actionId}
                    isValueCompproved={isRealValue(currentStatus)}
                    currency={currency}
                  />
                  <hr />
                </>
              </Col>
            ) : (
                ''
              )}
          </Row>
          <Row>
            {!!actionId ? (
              <Col md={2}>
                <Form.Group>
                  <Form.Label>{t('label:id')}</Form.Label>
                  <Form.Control value={actionId} disabled />
                </Form.Group>
              </Col>
            ) : null}
            <Col>
              <Form.Group>
                <Form.Label className="mr-2">
                  {t('label:action name')}
                </Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Insira aqui"
                  required
                  disabled={!editable}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label className="mr-2">{t('label:company')}</Form.Label>
                <Select
                  name="vendor"
                  key={VendorsArr[findVendors(company)]}
                  mode="input"
                  options={VendorsArr}
                  defaultValue={VendorsArr[findVendors(company)]}
                  placeholder={t('label:select')}
                  isDisabled={!editable || !!planId ? true : false}
                  required
                  onChange={handleChangeCompany}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:expected expense')}</Form.Label>
                <div className="row pl-3 pr-3">
                  <Form.Control
                    as="select"
                    value={currency}
                    onChange={(e) => {
                      handleChangeCurrency(e.target.value);
                    }}
                    disabled={!editable ? true : false}
                    className="col-3"
                  >
                    <option value="1">R$</option>
                    <option value="2">$</option>
                    <option value="3">€</option>
                  </Form.Control>
                  {getCurrency()}
                </div>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label className="mr-2">
                  {t('label:action type')}
                </Form.Label>
                <Form.Control
                  as="select"
                  value={atividade}
                  onChange={(e) => setAtividade(e.target.value)}
                  required
                  {...(!editable ? readOnlySelect : {})}
                >
                  <option disabled value="">
                    {t('label:select')}
                  </option>
                  <option value={'atividade'}>Atividade</option>
                  <option value={'evento'}>Evento</option>
                </Form.Control>
              </Form.Group>
            </Col>
            {showVendorId(currentStatus) ? (
              <Col>
                <Form.Group>
                  <Form.Label className="mr-2">
                    {t('label:vendor id')}
                  </Form.Label>
                  <Form.Control
                    value={vendorId}
                    onChange={(e) => setVendorId(e.target.value)}
                    {...(currentStatus != ActionStatus.ControllingApproval
                      ? readOnlySelect
                      : {})}
                  ></Form.Control>
                </Form.Group>
              </Col>
            ) : (
                ''
              )}
          </Row>
          {atividade === 'evento' ? (
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:event')}</Form.Label>
                  <Select
                    name="events"
                    mode="input"
                    options={EventsArr}
                    placeholder={t('label:select')}
                    required
                    isDisabled={!editable ? true : false}
                    defaultValue={getDefaultEvent(EventsArr)}
                    onChange={handleEventId}
                  />
                </Form.Group>
              </Col>
            </Row>
          ) : null}
          {atividadeDropDown}
          <Row>
            {rules ? (
              <Col md={4}>
                <Form.Group>
                  <Form.Label>{t('label:period')}</Form.Label>
                  <Form.Control
                    as="select"
                    value={rule}
                    onChange={handleChangePeriod}
                    disabled={rules.length === 0}
                    required
                    {...(!editable || !!planId ? readOnlySelect : {})}
                  >
                    <option value="">{t('label:select')}</option>
                    {rules.filter((f) => actionId && currentStatus != ActionStatus.Draft ? f : f.deleted_at == null).map((rule, k) => (
                      <option key={k} value={rule.id}>
                        {rule.fiscal_year} - {rule.period.type.name} {rule.period.position}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ) : (
                ''
              )}
            <Col>
              <Form.Group>
                {atividade === 'evento' ? (
                  <>
                    <Form.Label className="mr-3">
                      {t('label:payment date')}
                    </Form.Label>
                    <DatePicker
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      locale="pt_BR"
                      selected={paymentDate}
                      onChange={(date) => setPaymentDate(date)}
                      placeholderText={t('label:insert here')}
                      shouldCloseOnSelect={false}
                      required
                      disabled={!editable || rules?.length === 0}
                    />
                  </>
                ) : (
                    <>
                      <Form.Label className="mr-3">
                        {t('label:start date')}
                      </Form.Label>
                      <DatePicker
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        locale="pt_BR"
                        selected={startDate}
                        onChange={(date) => handleChangeStartDate(date)}
                        placeholderText={t('label:insert here')}
                        maxDate={endDate}
                        startDate={startDate}
                        endDate={endDate}
                        shouldCloseOnSelect={false}
                        required
                        disabled={!editable || rules?.length === 0}
                      />
                    </>
                  )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                {atividade === 'evento' ? (
                  <>
                    <Form.Group>
                      <Form.Label>{t('label:quota type')}</Form.Label>
                      <Form.Control
                        as="select"
                        required
                        value={quotaType}
                        onChange={(e) => setQuotaType(e.target.value)}
                        {...(!editable ? readOnlySelect : {})}
                      >
                        <option disabled value="">
                          {t('label:select')}
                        </option>
                        <option value={'black'}>Black</option>
                        <option value={'platinum'}>Platinum</option>
                        <option value={'silver'}>Silver</option>
                        <option value={'gold'}>Gold</option>
                        <option value={'plus'}>Plus</option>
                        <option value={'pos_barcode'}>POS & Barcode</option>
                      </Form.Control>
                    </Form.Group>
                  </>
                ) : (
                    <>
                      <Form.Label>{t('label:end date')}</Form.Label>
                      <DatePicker
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        locale="pt_BR"
                        selected={endDate}
                        onChange={(date) => handleChangeEndDate(date)}
                        placeholderText={t('label:insert here')}
                        minDate={startDate}
                        startDate={startDate}
                        endDate={endDate}
                        shouldCloseOnSelect={false}
                        required
                        disabled={!editable || rules?.length === 0}
                      />
                    </>
                  )}
              </Form.Group>
            </Col>
          </Row>
          <Row
            className="justify-content-md-center mb-3"
            style={{ display: taskItems.length === 0 ? 'none' : null }}
          >
            <Col md={12}>
              <Form.Group>
                <ActionsFormTasks
                  taskItems={taskItems}
                  setTaskItems={setTaskItems}
                  editable={editable}
                  task={task}
                  statusNow={statusNow}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Label>{t('label:brief description')}</Form.Label>
                <Form.Control
                  as="textarea"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows="4"
                  required
                  disabled={!editable}
                />
              </Form.Group>
            </Col>
          </Row>
          {atividade !== 'evento' ? null : (
            <>
              <Row className="mb-3">
                <Col>
                  <ExtraMaterial
                    extra_materials={extra_materials}
                    setExtraMaterials={setExtraMaterials}
                    deleted_extra_materials={deleted_extra_materials}
                    setDeletedExtraMaterials={setDeletedExtraMaterials}
                    editable={editable}
                  />
                </Col>
              </Row>
            </>
          )}
          {/*{getIsCriativo() ? (<>
            <Row>
              <Col xs="12"><h5>Briefing</h5></Col>
              <Col>
                <Form.Group>
                  <FileUploadMultiple
                    files={filesBriefing}
                    setFiles={setFilesBriefing}
                    filesComments={filesBriefingComments}
                    setFilesComments={setFilesBriefingComments}
                    existingFiles={actionExistingFilesBriefing}
                    disabled={actionId ? (currentStatus !== 5 && currentStatus !== 6 && currentStatus !== 22 && currentStatus !== 9 && currentStatus !== 26) : false}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>) : ''}*/}
          <Row>
            <Col xs="12"><h5>Arquivos</h5></Col>
            <Col>
              <Form.Group>
                {atividade === 'atividade' && currentStatus === 6 ? (
                  <FileUploadMultiple
                    files={files}
                    setFiles={setFiles}
                    filesComments={filesComments}
                    setFilesComments={setFilesComments}
                    existingFiles={actionExistingFiles}
                    disabled={editable}
                  />
                ) : (
                    <FileUploadMultiple
                      files={files}
                      setFiles={setFiles}
                      filesComments={filesComments}
                      setFilesComments={setFilesComments}
                      existingFiles={actionExistingFiles}
                      disabled={!editable}
                    />
                  )}
              </Form.Group>
            </Col>
          </Row>

        </Col>
      </Row>
      {!courtesy?(
      <Row
        className="mt-2"
        style={{ display: periodFunds.length === 0 ? 'none' : null }}
      >
        <Col>
          <ActionsFormFunds
            planId={planId}
            position={position}
            funds={funds}
            setFunds={setFunds}
            fundExtra={fundExtra}
            setFundExtra={setFundExtra}
            periodFunds={periodFunds}
            editable={editable}
            totalFundsExpireValue={totalFundsExpireValue}
            setTotalFundsExpireValue={setTotalFundsExpireValue}
            currency={currency}
          />
        </Col>
      </Row>
      ):''}
    </>
  );
};

export default ActionsFormAction;
